export default __webpack_public_path__ + "static/tintash-logo-blue-be671bb70f58af2e5f9f71a9daa455f0.svg";